import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUserGroupIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5.645 7.567a1.13 1.13 0 1 0 2.258 0 1.13 1.13 0 0 0-2.258 0M4.517 12.084v-.564a1.13 1.13 0 0 1 1.129-1.13h2.258a1.13 1.13 0 0 1 1.129 1.13v.564M8.468 3.05a1.13 1.13 0 1 0 2.258 0 1.13 1.13 0 0 0-2.258 0M9.598 5.875h1.129a1.13 1.13 0 0 1 1.129 1.13v.564M2.823 3.05a1.13 1.13 0 1 0 2.258 0 1.13 1.13 0 0 0-2.258 0M1.693 7.569v-.565a1.13 1.13 0 0 1 1.13-1.129H3.95"
    />
  </svg>
);
export default SvgUserGroupIcon;
